import { render, staticRenderFns } from "./importDeclare.vue?vue&type=template&id=6a156784&scoped=true"
import script from "./importDeclare.vue?vue&type=script&lang=js"
export * from "./importDeclare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a156784",
  null
  
)

export default component.exports